import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableLiveScheduledProviders from './tableLiveScheduledProviders';


export default {
  title: 'Live Scheduled Providers',
  attributeName: 'liveScheduledProviders',
  fields: [
    {
      attributeName: 'liveScheduledProvidersTable',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableLiveScheduledProviders,
    },

  ],
};
